import { UserFilters } from "../types/filter";
import { CreateUser, UpdateUserStatusRequest, UserInfo } from "../types/user";
import { apiSlice } from "../lib/baseQuery";

const BASE_URL = "api/user"

export const userApi = apiSlice.injectEndpoints({
    endpoints: (build) => ({
        getUsers: build.query<UserInfo[], UserFilters>({
            query: (filters: UserFilters) => {
                const queryString = new URLSearchParams(filters).toString();
                return BASE_URL + `?${queryString}`;
            },
            keepUnusedDataFor: 0
        }),
        getUserById: build.query<UserInfo, number>({
            query: (userId: number) => `${BASE_URL}/${userId}`,
            keepUnusedDataFor: 0,
            providesTags: ["getUserById"],
        }),
        createUser: build.mutation<void, CreateUser>({
            query: (request: CreateUser) => ({
                url: BASE_URL,
                method: "POST",
                body: request,
            }),
        }),
        changeUserStatus: build.mutation<void, UpdateUserStatusRequest>({
            query: (request: UpdateUserStatusRequest) => ({
                url: `${BASE_URL}/status/${request.userId}`,
                method: "PUT",
                body: {
                    status: request.newStatus,
                }
            }),
            invalidatesTags: ["getUserById"],
        })
    }),

})

export const {
    useGetUsersQuery,
    useLazyGetUsersQuery,
    useGetUserByIdQuery,
    useCreateUserMutation,
    useChangeUserStatusMutation
} = userApi;